<div *ngFor="let formComponent of customFormComponents">
  <ng-container [ngSwitch]="formComponent.component">
    <!-- Case for 'app-create-and-view-notes' component -->
    <div class="table mt-0100"
         *ngSwitchCase="'app-create-and-view-notes'">
      <div class="tr tr--noGutter tile__heading pt-0 pb-0">
        Entity Notes
      </div>
      <div class="tr tr--noGutter">
        <app-create-and-view-notes [targetType]="'Entity'"
                                   [targetId]="entity.id"
                                   [campaignId]="entity.campaignContextId"
                                   [shouldAutofocusInput]="false"
                                   class="col__"></app-create-and-view-notes>
      </div>
    </div>

    <!-- Case for 'app-entity-phones-table' component -->
    <div *ngSwitchCase="'app-entity-phones-table'">
      <app-entity-phones-table [entityId]="entity.id"
                               [campaignId]="entity.campaignContextId"
                               class="d-block mt-0100">
      </app-entity-phones-table>
    </div>

    <!-- Case for 'app-entity-addresses-table' component -->
    <div *ngSwitchCase="'app-entity-addresses-table'">
      <app-entity-addresses-table [entityId]="entity.id"
                                  [campaignId]="entity.campaignContextId"
                                  class="d-block mt-0100">
      </app-entity-addresses-table>
    </div>

    <!-- Case for 'app-entity-emails-table' component -->
    <div *ngSwitchCase="'app-entity-emails-table'">
      <app-entity-emails-table [entityId]="entity.id"
                               [campaignId]="entity.campaignContextId"
                               class="d-block mt-0100">
      </app-entity-emails-table>
    </div>

    <!-- Case for 'app-applied-tag-category-table' component -->
    <div *ngSwitchCase="'app-applied-tag-category-table'">
      <app-applied-tag-category-table [category]="formComponent.formField.tagCategory"
                                      [target]="entity"
                                      [campaignId]="entity.campaignContextId"
                                      class="d-block mt-0100">
      </app-applied-tag-category-table>
    </div>

    <!-- Case for 'app-entity-connection-table' component -->
    <div *ngSwitchCase="'app-entity-connection-table'">
      <app-entity-connection-table [entityConnectionType]="formComponent.formField.entityConnectionType"
                                   [entityId]="entity.id"
                                   [entityTypeId]="entity.entityTypeId"
                                   [campaignId]="entity.campaignContextId"
                                   class="d-block mt-0100"></app-entity-connection-table>
    </div>

    <!-- Case for 'app-entity-social-table' component -->
    <div *ngSwitchCase="'app-entity-social-table'">
      <app-entity-social-table [entityId]="entity.id"
                               [campaignId]="entity.campaignContextId"
                               class="d-block mt-0100">
      </app-entity-social-table>
    </div>

    <!-- Case for 'app-entity-name-table' component -->
    <div *ngSwitchCase="'app-entity-name-table'">
      <app-entity-name-table [entityId]="entity.id"
                             [campaignId]="entity.campaignContextId"></app-entity-name-table>
    </div>

    <!-- Case for 'app-entity-dob-table'-->
    <div *ngSwitchCase="'app-entity-dob-table'">
      <app-entity-dob-table [entityId]="entity.id"
                            [campaignId]="entity.campaignContextId"
                            class="d-block mt-0100">
      </app-entity-dob-table>
    </div>

    <!-- Case for 'app-entity-language-table' component -->
    <div *ngSwitchCase="'app-entity-language-table'">
      <app-entity-language-table [entityId]="entity.id"
                                 [campaignId]="entity.campaignContextId"
                                 class="d-block mt-0100">
      </app-entity-language-table>
    </div>

    <!-- Case for 'app-entity-assessment-add' component -->
    <div *ngSwitchCase="'app-entity-assessment-add'">
      <div class="table col__ mt-0100">
        <div class="tr tile__heading">
          Update Assessment
          <app-assessment-badge [level]="entity.currentAssessmentLevel"
                                [entityTypeId]="entity.entityTypeId"
                                class="ml-0050"></app-assessment-badge>

        </div>
        <div class="tr tr--noGutter col__ pt-0">
          <app-entity-assessment-add [horizontal]="true"
                                     [entityId]="entity.id"
                                     [entityTypeId]="entity.entityTypeId"
                                     [campaignId]="entity.campaignContextId"
                                     (saved)="triggerRefetch()"
                                     class="d-block w-100">
          </app-entity-assessment-add>
        </div>
      </div>
    </div>

    <!-- Default case (if component doesn't match any known case) -->
    <div *ngSwitchDefault>
      Component not recognized
    </div>
  </ng-container>
</div>
